<template>
  <div>
    <Main/>
  </div>
</template>

<script>
import Main from "../alamos/maplocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
};
</script>
